export default {
  name: "EventConnections",
  props: ["editedEvent", "step", "position", "isOwnedBySubPrincipal"]
};
